export default {"src":"/_next/static/media/password-visible.aad7c5df.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};